<template>
	<el-container class="outContainer">
		<el-header :style="{ backgroundColor: primaryColor, height: state.headerHeight + 'px' }" v-show="!shrink">
			<headerVue ref="headerRef"></headerVue>
		</el-header>
		<el-container v-if="showPlatForm">
			<platFormContainer @setTab="setTab"></platFormContainer>
		</el-container>
		<el-container v-show="!showPlatForm">
			<el-aside width="260px" v-show="!shrink">
				<asideVue ref="asideRef" @nodeClick="hidePopover"></asideVue>
			</el-aside>
			<el-main>
				<mainContentVue ref="contentRef" @treeChange="treeChange"></mainContentVue>
			</el-main>
			<div class="nav-collspan" v-if="state.showExpand" :style="{ left: shrink ? '0px' : '240px' }">
				<svgIcon @click="expand" class="expand" v-if="shrink" :color="primaryColor" width="20px" height="20px"
					name="expand" :title="$t('dataProcessUnit.expand')" :hover="false"> </svgIcon>
				<svgIcon @click="collspanLeft" class="collspan" v-else :color="primaryColor" width="20px" height="20px"
					name="collspan" :title="$t('dataProcessUnit.collspan')" :hover="false"></svgIcon>
			</div>
		</el-container>
	</el-container>
</template>

<script setup>
import headerVue from "./header.vue";
import asideVue from "./aside.vue";
import mainContentVue from "./mainContent.vue";
import { ref, reactive, nextTick, computed, onMounted, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import platFormContainer from "@views/platformSetting/platFormContainer.vue";
import { SignalRInstance } from "@common/js/signalRClient";
import { ClientRealContext } from "@core/js/clientRealContext";
import { setPhmTheme, setPhmPrimaryColor, i18nGlobal } from "@common/js/utils";
import axios from "@common/js/axios";
import { ParentGuid } from "@common/js/enum";
import svgIcon from "@common/components/svgIcon.vue";
import { LabelPointAlarmClinetInstance } from "@components/js/utils/labelPointAlarmClinet";

const asideRef = ref(null);
const headerRef = ref(null);
const contentRef = ref(null);

const route = useRoute();
const store = useStore();
const showPlatForm = computed(() => store.state.showPlatForm);
const primaryColor = computed(() => store.state.primaryColor);
const shrink = computed(() => store.state.shrink);
const state = reactive({
	fixedThemes: [
		{
			Name: i18nGlobal("login.lightTheme"),
			active: false,
			fixed: true,
			CardColor: "#FFFFFF",
			GraphTheme: false,
			BackgroundColor: "#F9FAFC",
			SeparatorColor: "#EEEEEE",
			TextColor: "#666666",
			ThemeColor: "#409eff",
			TitleColor: "#333333",
			TooltipColor: "#CCCCCC",
		},
		{
			Name: i18nGlobal("login.darkTheme"),
			active: false,
			choose: false,
			fixed: true,
			CardColor: "#020c34",
			GraphTheme: true,
			BackgroundColor: "#00092c",
			SeparatorColor: "#0f4182",
			TextColor: "#b4cbdb",
			ThemeColor: "#409eff",
			TitleColor: "#f9fafc",
			TooltipColor: "#195d9b",
		},
	],
	headerHeight: 30,
	showExpand: true,
});

const collspanLeft = () => {
	store.commit("setShrink", { shrink: true });
};

const expand = () => {
	store.commit("setShrink", { shrink: false });
};

const hidePopover = () => {
	headerRef.value?.hidePopover();
};

// 右侧按钮操作后通知树进行更新
const treeChange = (obj) => {
	asideRef.value.updateTree(obj);
};

const setTab = () => {
	contentRef.value?.turnToPage();
};

const clearRegister = () => {
	ClientRealContext.Clear();
	SignalRInstance.Clear();
};

const setPrimaryColor = (color) => {
	store.commit("setPrimaryColor", { primaryColor: color });
};

const setTheme = (theme) => {
	const data = { ...theme };
	delete data.primary;
	store.commit("setThemeColor", { theme: data });
};

const getThemes = () => {
	axios({
		method: "get",
		url: `/Theme/curtheme/${store.state.userInfo.UserId}`,
	}).then((res) => {
		if (res.IsSuccess) {
			if (res.Result) {
				if (res.Result.Id === ParentGuid) {
					setPrimaryColor(state.fixedThemes[0].ThemeColor);
					setTheme({ ...state.fixedThemes[0], GraphTheme: res.Result.GraphTheme });
				} else if (res.Result.Id === "00000000-0000-0000-0000-000000000001") {
					setPrimaryColor(state.fixedThemes[1].ThemeColor);
					setTheme({ ...state.fixedThemes[1], GraphTheme: res.Result.GraphTheme });
				} else {
					setPrimaryColor(res.Result.ThemeColor);
					setTheme(res.Result);
				}
			} else {
				setPrimaryColor(state.fixedThemes[0].ThemeColor);
				setTheme({ ...state.fixedThemes[0], GraphTheme: false });
			}
			nextTick(() => {
				setPhmPrimaryColor(store.state.primaryColor, store);
				setPhmTheme(store.state.customColor, store);
			});
		}
	});
};

onMounted(() => {
	state.headerHeight = store.state.licenseInfo?.TitleHeight ?? 30;
	window.MachineTree = asideRef.value;
	window.Header = headerRef.value;
	window.MainContent = contentRef.value;
	window.onNavigateChanged = new Map();
	window.onUnitRemoved = new Map();
	window.onRefresh = new Map();
	window.threedModels = new Map();
	state.showExpand = window.showExpandBtn == null ? true : window.showExpandBtn;
	window.onExpandBtnChanged = (v) => {
		state.showExpand = v;
	}
	store.dispatch("getEigens");
	document.oncontextmenu = function (e) {
		return false;
	};
	getThemes();
	SignalRInstance.initial(Config.signalRUrl, Config.url);
	ClientRealContext.initial();
	LabelPointAlarmClinetInstance.initial();
	window.addEventListener("beforeunload", clearRegister);
});

onBeforeUnmount(() => {
	LabelPointAlarmClinetInstance.Clear();
	ClientRealContext.Clear();
	SignalRInstance.Clear();
	window.removeEventListener("beforeunload", clearRegister);
	window.MachineTree = null;
	window.Header = null;
	window.MainContent = null;
	window.onNavigateChanged = null;
	window.onUnitRemoved = null;
	window.onRefresh = null;
	window.threedModels = null;
	window.onExpandBtnChanged = null;
});
</script>

<style scoped lang="less">
@import "@styles/variable.less";

.outContainer {
	height: 100%;

	.el-container {
		flex: 1;
		overflow: auto;

		// height: auto;
		height: calc(100% - 30px);

		.el-aside {
			background-color: var(--phm-theme-card);
			border-right: 1px solid var(--phm-theme-border);
		}

		.el-main {
			padding: 0;
			background-color: var(--phm-theme-background);
			display: flex;
			flex-direction: column;
			max-height: 100%;
			overflow: hidden;
		}
	}
}

.nav-collspan {
	position: absolute;
	top: calc(50% - 30px);
	width: 20px;
	height: 60px;
}
</style>
